import React, { FC, useState } from 'react'

import { usePathname } from 'next/navigation'

import {
  LEGAL_BANNER_COOKIE,
  LEGAL_BANNER_COOKIE_ACCEPTED,
  LEGAL_BANNER_COOKIE_DECLINED,
  LEGAL_BANNER_COOKIE_VALUE,
  LEGAL_BANNER_SELECTION_COOKIE,
} from '@/constants'
import { useLegalBannerContext } from '@/contexts/LegalBannerContext'
import { PrivacyCenter } from '@/shared/martech/PrivacyCenter'
import Cookies from 'js-cookie'
import { legalBannerAnalytics } from 'lib/@getethos/analytics/analyticsEvents'

import { useIsSofi } from '@/hooks/cobranded/useIsSofi'

import Markdown from '../../Markdown'
import { TransparentBanner } from './components/TransparentBanner'

interface IPolicyBanner {
  open: boolean
  setOpen: (open: boolean) => void
}

export const PolicyBanner: FC<IPolicyBanner> = ({ open, setOpen }) => {
  const isSofi = useIsSofi()

  const { setIsDisclaimerOpen } = useLegalBannerContext()
  const pathname = usePathname()

  const contentMarkdownText = `
  This site uses cookies and other technologies described in ${
    isSofi ? `Ethos'` : 'our'
  } [Privacy Policy](/privacy/).  
  
  By clicking “Accept,” you agree to ${
    isSofi ? `Ethos'` : 'our'
  } [Terms of Use](/terms/) and [Privacy Policy](/privacy/).
  `

  const isTerms = pathname === '/terms/'

  const handleAccept = (event: React.MouseEvent | React.KeyboardEvent) => {
    // Accept policy
    legalBannerAnalytics.legalBannerDismissed({
      action: 'accept',
    })
    Cookies.set(LEGAL_BANNER_COOKIE, LEGAL_BANNER_COOKIE_VALUE, {
      expires: 365,
    })
    Cookies.set(LEGAL_BANNER_SELECTION_COOKIE, LEGAL_BANNER_COOKIE_ACCEPTED, {
      expires: 365,
    })
    setOpen(false)
    setIsDisclaimerOpen(false)
    PrivacyCenter.OptIn(event)
  }

  const handleDismiss = (event: React.MouseEvent | React.KeyboardEvent) => {
    // Dismiss policy
    legalBannerAnalytics.legalBannerDismissed({
      action: 'dismiss',
    })
    Cookies.set(LEGAL_BANNER_COOKIE, LEGAL_BANNER_COOKIE_VALUE, {
      expires: 365,
    })
    Cookies.set(LEGAL_BANNER_SELECTION_COOKIE, LEGAL_BANNER_COOKIE_DECLINED, {
      expires: 365,
    })
    setOpen(false)
    setIsDisclaimerOpen(false)
    PrivacyCenter.OptOut(event)
  }

  if (!open || isTerms) return null

  return (
    <TransparentBanner
      content={<Markdown input={contentMarkdownText} />}
      onAccept={handleAccept}
      onDismiss={handleDismiss}
    />
  )
}
